<app-base-compare id="app-base-compare"></app-base-compare>
